export default __webpack_public_path__ + "static/media/Tick_White.3c467732.svg";